
export class ReportDT0 {
  dashboardParams: any;
  dashboardSpec: any;
}